import { FooterState } from "../../entites/footer-themes.model";
import { ActionsUnion } from "./FooterThemes.actions";
import { FOOTER_CATEGORIES_LOADED, SITE_THEME_LOADED, SOCIALS_LOADED, STATIC_PAGES_LOADED } from "./constants/constants";




function getIntialState()
{
  let initialState : FooterState  = {
    footer_categories : [],
    static_pages: [],
    socials: [],
    site_theme: []
  };

  return initialState
}



export function footerThemeReducer (state = getIntialState(), action: ActionsUnion) 
{

  switch ( action.type ) 
  {

    case FOOTER_CATEGORIES_LOADED:
      return {
        ...state,
        footer_categories: action.data
      };


    case STATIC_PAGES_LOADED:
      return {
        ...state,
        static_pages: action.data
      };


    case STATIC_PAGES_LOADED:
      return {
        ...state,
        static_pages: action.data
      };

    case SOCIALS_LOADED:
      return {
        ...state,
        socials: action.data
      };

    case SITE_THEME_LOADED:
      return {
        ...state,
        site_theme: action.data
      };


    default:
    return state;

  }

}
